import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import InputData from "./InputData";
import TooltipBox from "./Tooltip";

export function ProductFeatures({
  family,
  productFamilyName,
  list,
  columns,
  onDelete,
  onDeleteAll,
  createPopupQuestion,
  removePopupQuestion,
  draft,
  onChange,
  tabStartIndex,
}) {
  const [productList, setProductList] = useState([]);
  const [currentSummary, setCurrentSummary] = useState({});

  const columnsWithInputs = columns.map((col) => {
    if (col.name === "Stock") {
      return {
        ...col,
        cell: (row, rowIndex) =>
          row.idProductoAlbaran !== "summary" ? (
            <InputData
              size={0}
              type="type-positive-nonzero"
              input={row.stock}
              tabIndex={tabStartIndex + rowIndex}
              onChange={(e) => {
                setProductList((prevList) =>
                  prevList.map((product) =>
                    product.idProductoAlbaran === row.idProductoAlbaran
                      ? { ...product, stock: e === "" ? "" : parseInt(e) }
                      : product,
                  ),
                );
              }}
              onBlur={() => {
                setProductList((prevList) => {
                  const updatedList = prevList.map((product) => {
                    if (
                      product.idProductoAlbaran === row.idProductoAlbaran &&
                      product.stock === ""
                    ) {
                      const originalProduct = list.find(
                        (p) => p.idProductoAlbaran === row.idProductoAlbaran,
                      );
                      return { ...product, stock: originalProduct.stock };
                    }
                    return product;
                  });

                  const totalStock = updatedList.reduce(
                    (sum, item) => sum + (Number(item.stock) || 0),
                    0,
                  );

                  setCurrentSummary((prev) => ({
                    ...prev,
                    stock: totalStock,
                  }));

                  if (onChange) {
                    onChange(updatedList);
                  }

                  return updatedList;
                });
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {currentSummary.stock}
            </div>
          ),
      };
    }

    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.idProductoAlbaran !== "summary" && draft ? (
            <>
              <img
                src={`/images/remove-blue.svg`}
                data-tooltip-id={row.idProductoAlbaran}
                className="icon-pref"
                alt="Eliminar producto"
                onClick={() => {
                  createPopupQuestion(
                    `¿Desea eliminar el producto?`,
                    async () => {
                      onDelete(family, row.idProductoAlbaran);
                      removePopupQuestion();
                    },
                    removePopupQuestion,
                    "Sí",
                    "No",
                  );
                }}
              ></img>
              <TooltipBox
                id={String(row.idProductoAlbaran)}
                content={
                  <div className="opt-table-tooltip grid-5">
                    <div className="cell combined-cells-5 cell-start-content">
                      Borrar
                    </div>
                  </div>
                }
              ></TooltipBox>
            </>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  useEffect(() => {
    setProductList(list);
  }, [list]);

  useEffect(() => {
    if (productList.length > 0) {
      const totalStock = productList.reduce(
        (sum, item) => sum + (Number(item.stock) || 0),
        0,
      );
      const totalPVO = productList.reduce(
        (sum, item) => sum + (item.pvo !== "" ? Number(item.pvo) : 0),
        0,
      );
      const totalPVP = productList.reduce(
        (sum, item) => sum + (typeof item.pvp === "number" ? item.pvp : 0),
        0,
      );
      const summaryRow = {
        idProductoAlbaran: "summary",
        stock: totalStock,
        pvo: totalPVO > 0 ? parseFloat(totalPVO.toFixed(2)) : "",
        pvp: parseFloat(totalPVP.toFixed(2)),
      };

      setCurrentSummary(summaryRow);
    }
  }, [productList]);

  return (
    <>
      {productList.length > 0 && (
        <div className="delivery-note-table-info-container">
          <div className="opt-table-title">
            {productFamilyName} ({list.length})
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
              justifyContent: "flex-end",
              padding: "0 0 5px 0",
            }}
          >
            <button
              className="cell-label"
              onClick={() => {
                createPopupQuestion(
                  `¿Desea eliminar todos los productos de la familia ${productFamilyName}?`,
                  async () => {
                    onDeleteAll(family, productList);
                    removePopupQuestion();
                  },
                  removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            >
              Borrar todo
            </button>
          </div>
          <div className="delivery-note-table">
            <DataTable
              columns={columnsWithInputs}
              data={productList}
              className="custom-datatable non-interactive"
              noDataComponent="No hay productos disponibles."
              selectableRows={false}
            />
            <DataTable
              columns={columnsWithInputs}
              data={[currentSummary]}
              noDataComponent="No hay datos disponibles."
              className="custom-datatable summary-row no-header-datatable"
              noHeader
            />
          </div>
        </div>
      )}
    </>
  );
}
